import { TagTypeProps } from "components/DesignSystem/Tag/Tag";
import { VendorBill } from "types/Models/vendorBills";
import BillCom from "static/images/BillCom.svg";

export const BILL_STATUS = {
  DRAFT: "DRAFT",
  DUE: "DUE",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
  IN_REVIEW: "IN_REVIEW",
  APPROVED: "APPROVED",
  PARTIALLY_PAID: "PARTIALLY_PAID",
} as const;

export type billStatusType = keyof typeof BILL_STATUS;

export const BILL_STATUS_LABEL = {
  [BILL_STATUS.DRAFT]: "Draft",
  [BILL_STATUS.DUE]: "Due",
  [BILL_STATUS.OVERDUE]: "Overdue",
  [BILL_STATUS.PAID]: "Paid",
  [BILL_STATUS.IN_REVIEW]: "In Review",
  [BILL_STATUS.APPROVED]: "Approved",
  [BILL_STATUS.PARTIALLY_PAID]: "Partially paid",
};

export const TAX_TYPE = {
  PERCENT: "PERCENT",
  ABSOLUTE: "ABSOLUTE",
} as const;

export const FINANCIAL_RECORD_TYPE = {
  BILL: "BILL",
  REQUEST: "REQUEST",
} as const;

export const BILL_STATE = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export const CUSTOMER_AI_STATUS = {
  CREATED: "CREATED",
  USED_EXISTING: "USED_EXISTING",
  FAILED_TO_CREATE_OR_MATCH: "FAILED_TO_CREATE_OR_MATCH",
  MANUAL: "MANUAL",
  NA: "NA",
} as const;

export const TAG_TYPE: Record<
  VendorBill["bill_payment_status"],
  TagTypeProps["tagType"]
> = {
  [BILL_STATUS.DRAFT]: "gray",
  [BILL_STATUS.DUE]: "orange",
  [BILL_STATUS.OVERDUE]: "red",
  [BILL_STATUS.PAID]: "green",
  [BILL_STATUS.IN_REVIEW]: "purple",
  [BILL_STATUS.APPROVED]: "green",
  [BILL_STATUS.PARTIALLY_PAID]: "orange",
};

export const STATUS_HEADER = {
  [FINANCIAL_RECORD_TYPE.BILL]: "PAYMENT STATUS",
  [FINANCIAL_RECORD_TYPE.REQUEST]: "REQUEST STATUS",
} as const;

export const DATE_HEADER = {
  [FINANCIAL_RECORD_TYPE.BILL]: "DUE DATE",
  [FINANCIAL_RECORD_TYPE.REQUEST]: "REQUEST DATE",
} as const;

export const BILLS_SOURCES = {
  MANUAL: { label: "Manually added", value: "MANUAL", icon: "ICON" },
  BILL_COM: { label: "Bill.com", value: "BILL_COM", icon: BillCom },
  FORWARDED_VIA_EMAIL: {
    label: "Bill Forwarding",
    value: "FORWARDED_VIA_EMAIL",
    icon: "ICON",
  },
};
export const BILLS_STATUS_MAP = {
  MANUAL: { label: BILL_STATUS_LABEL.OVERDUE, value: BILL_STATUS.OVERDUE },
  DUE: { label: BILL_STATUS_LABEL.DUE, value: BILL_STATUS.DUE },
  DRAFT: { label: BILL_STATUS_LABEL.DRAFT, value: BILL_STATUS.DRAFT },
  PAID: { label: BILL_STATUS_LABEL.PAID, value: BILL_STATUS.PAID },
  PARTIALLY_PAID: {
    label: BILL_STATUS_LABEL.PARTIALLY_PAID,
    value: BILL_STATUS.PARTIALLY_PAID,
  },
};
export type BILL_SOURCES_TYPE = keyof typeof BILLS_SOURCES;

export const BILL_STATUS_OPTIONS = [
  { label: "Paid", value: BILL_STATUS.PAID },
  {
    label: "Partially Paid",
    value: BILL_STATUS.PARTIALLY_PAID,
  },
  { label: "Due", value: BILL_STATUS.DUE },
  { label: "Overdue", value: BILL_STATUS.OVERDUE },
];

export const WITHHOLDING_STATUS = {
  WITHHELD: "WITHHELD",
  PAID_TO_IRS: "PAID_TO_IRS",
} as const;

export type withholdingStatusType = keyof typeof WITHHOLDING_STATUS;

export const WITHHOLDING_STATUS_LABEL = {
  [WITHHOLDING_STATUS.WITHHELD]: "Withheld",
  [WITHHOLDING_STATUS.PAID_TO_IRS]: "Paid to IRS",
};

export const BILL_STATUS_GROUP_TYPES = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
} as const;

export type BILL_STATUS_GROUP_TYPES_TYPE = keyof typeof BILL_STATUS_GROUP_TYPES;

export const ACTIVE_BILL_STATUSES = [
  BILL_STATUS.PAID,
  BILL_STATUS.PARTIALLY_PAID,
  BILL_STATUS.DUE,
  BILL_STATUS.OVERDUE,
];

export const BILL_STATUS_GROUP_DATA_MAP: {
  [key in BILL_STATUS_GROUP_TYPES_TYPE]: {
    value: BILL_STATUS_GROUP_TYPES_TYPE;
    label: string;
    statuses: (keyof typeof BILL_STATUS)[];
  };
} = {
  [BILL_STATUS_GROUP_TYPES.ACTIVE]: {
    value: BILL_STATUS_GROUP_TYPES.ACTIVE,
    label: "Active",
    statuses: ACTIVE_BILL_STATUSES,
  },
  [BILL_STATUS_GROUP_TYPES.DRAFT]: {
    value: BILL_STATUS_GROUP_TYPES.DRAFT,
    label: "Draft",
    statuses: [],
  },
};
